<template>
  <div class="getinvolved">
    <h2>Get Involved <span>With Us</span></h2>
    <router-link to="/" class="backtoprojects-top"
      >&lt; back to projects</router-link
    >
    <h3>
      {{ introText }}
    </h3>
    <h3>
      {{ introText2 }}
    </h3>

    <!-- proposal block -->
    <div class="getinvolved-block-wrapper">
      <router-link
        v-bind:to="'/proposal/' + proposal.slug"
        v-for="(proposal, index) in proposals"
        :key="index"
        class="getinvolved-block"
      >
        <!-- <router-link to="/proposal"> -->
        <h4>{{ proposal.title }}</h4>
        <h5>{{ proposal.workArea }}</h5>
        <p>{{ proposal.intro }}</p>
        <div class="getinvolved-links">
          <router-link v-bind:to="'/proposal/' + proposal.slug"
            >read more</router-link
          >
          <div class="getinvolved-links--social">
            <social-sharing
              :url="'http://blue-temple.com/proposal/' + proposal.slug"
              title="Blue Temple social title"
              description="Blue Temple social"
              quote="Blue Temple social"
              hashtags="bluetemple"
              twitter-user="bluetemple"
              inline-template
            >
              <div>
                <network network="facebook">
                  <svg
                    class="social-share"
                    height="40.22"
                    viewBox="-21 -21 682.67 682.67"
                    width="40.22"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M604.67 0H35.3A35.32 35.32 0 000 35.33V604.7A35.32 35.32 0 0035.33 640h306.55V392.5h-83.13v-96.88h83.13v-71.29c0-82.67 50.47-127.67 124.22-127.67 35.32 0 65.68 2.63 74.53 3.8v86.42h-50.86c-40.13 0-47.9 19.06-47.9 47.05v61.7h95.94l-12.5 96.87h-83.43V640h162.8c19.5 0 35.32-15.8 35.32-35.31V35.3C640 15.8 624.18 0 604.67 0zm0 0"
                    />
                  </svg>
                </network>
                <network network="twitter">
                  <svg
                    class="social-share"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      d="M512 97.25a218.84 218.84 0 01-60.48 16.57c21.76-12.99 38.37-33.4 46.18-58.01a209.77 209.77 0 01-66.56 25.4A105.18 105.18 0 00354.46 48c-58.1 0-104.9 47.17-104.9 105 0 8.31.71 16.31 2.44 23.93-87.26-4.26-164.48-46.08-216.35-109.8a105.68 105.68 0 00-14.37 53.06c0 36.35 18.72 68.58 46.62 87.23-16.86-.32-33.4-5.21-47.42-12.92v1.15c0 51 36.38 93.37 84.1 103.13a104.76 104.76 0 01-27.52 3.46c-6.72 0-13.5-.38-19.88-1.8 13.6 41.58 52.2 72.14 98.08 73.13a210.9 210.9 0 01-130.14 44.77c-8.6 0-16.86-.39-25.12-1.44C46.5 446.88 101.6 464 161.02 464c193.16 0 298.76-160 298.76-298.69 0-4.64-.16-9.12-.39-13.57 20.83-14.78 38.34-33.24 52.61-54.5z"
                    />
                  </svg>
                </network>
              </div>
            </social-sharing>
          </div>
        </div>
        <!-- </router-link> -->
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "proposals",
  data() {
    return {
      proposals: [],
      introText: "",
      introText2: ""
    };
  },
  created() {
    var self = this;

    axios
      .get("https://api.blue-temple.com/work-proposals")
      .then(function(data) {
        self.proposals = data.data.data;

      })
      .catch(function() {});

    // get the intro text from config api
    axios
      .get("https://api.blue-temple.com/configuration")
      .then(function(res) {
        var introTextObj = res.data.data.filter(obj => {
          return obj.key === "GET_INVOLVED_INTRO";
        });
        self.introText = introTextObj[0]["defaultValue"];

        var introTextObj2 = res.data.data.filter(obj => {
          return obj.key === "GET_INVOLVED_INTRO_subtext";
        });
        self.introText2 = introTextObj2[0]["defaultValue"];
      })
      .catch(function() {});
  },
  beforeCreate: function() {
    document.body.className = "class-getinvolved";
  }
};
</script>

<style scoped lang="scss">
.getinvolved {
  display: block;
  min-height: 100vh;
  padding: 20px;

  h2 {
    display: block;
    margin-bottom: 20px;
    font-family: "rajdhanibold";
    font-size: 26px;
    font-weight: normal;
    text-transform: uppercase;
    color: $color-light;

    span {
      display: block;
      font-family: "rajdhaniregular";
    }
  }

  h3 {
    display: block;
    font-family: "rajdhaniregular";
    font-size: 18px;
    font-weight: normal;
    color: $color-light;

    + h3 {
      margin-top: 6px;
      font-size: 14px;
    }
  }

  &-block {
    display: block;
    margin-top: 20px;
    padding: 20px;
    background: $color-darkgrey-bg;
    text-decoration: none;

    &:active {
      border: 2px solid $color-light;
    }

    &:first-of-type {
      margin-top: 40px;
    }

    > a {
      text-decoration: none;
    }

    h4,
    h5 {
      display: block;
      margin: 0;
      font-size: 20px;
      color: $color-light;
    }

    h4 {
      font-family: "rajdhanibold";
    }

    h5 {
      font-family: "rajdhaniregular";
    }

    p {
      display: block;
      margin: 20px 0;
      font-family: "rajdhaniregular";
      font-size: 14px;
      line-height: 20px;
      color: $color-light;
      text-decoration: none;
    }
  }

  &-links {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    a {
      display: block;
      font-family: "rajdhaniregular";
      font-size: 14px;
      line-height: 20px;
      color: $color-light;
      text-decoration: none;
    }

    &--social {
      div {
        display: flex;
        flex-direction: row;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .getinvolved {
    height: 100vh;
    overflow-y: scroll;

    h3 {
      font-size: 20px;
    }

    h4,
    h5 {
      font-size: 20px;
    }
  }
}

@media screen and (min-width: 1024px) {
  .getinvolved {
    position: relative;
    height: 100vh;
    padding: 3.1vw;
    overflow-y: scroll;

    h2 {
      margin-top: 8px;
      margin-bottom: 30px;
      font-size: 52px;
      line-height: 48px;
    }

    h3 {
      max-width: 33vw;
      font-size: 24px;
      line-height: 28px;

      + h3 {
        font-size: 18px;
        line-height: 24px;
      }
    }

    .backtoprojects-top {
      margin-top: 8px;
    }

    &-block-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
    }

    &-block {
      display: block;
      width: calc(50% - 30px);
      padding: 30px;
      margin-top: 60px;
      border: 2px solid transparent;

      &:first-of-type {
        margin-top: 60px;
      }

      &:hover {
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
        border: 2px solid $color-light;
      }

      h4,
      h5 {
        font-size: 30px;
      }

      p {
        font-size: 18px;
        line-height: 24px;
        text-align: justify;
      }
    }

    &-links {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      a {
        display: block;
        font-family: "rajdhaniregular";
        font-size: 18px;
        line-height: 20px;
        color: $color-light;
        text-decoration: none;

        &:hover {
          // cursor: pointer;
          cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
          font-family: "rajdhanibold";
          text-transform: uppercase;
        }
      }

      &--social {
        div {
          display: flex;
          flex-direction: row;
        }
      }
    }
  }
}
</style>
